import { CancelToken } from 'axios';
import axios from '../../utils/axios';

const getMassivesPerPage = async ({
  page, limit, sectionIdFilter, programNameFilter, sort, year,
}: {
  page: number | string;
  limit: number | string;
  sectionIdFilter: string;
  programNameFilter: string;
  sort: string;
  year?: number;
}, cancelToken?: CancelToken) => {
  let url = `/api/massives?page=${page}&limit=${limit}&sectionIdFilter=${sectionIdFilter}&programNameFilter=${programNameFilter}&sort=${sort}`;
  if (year) {
    url += `&year=${year}`;
  }
  const response = await axios.get(url, { cancelToken });

  return response.data;
};

const postMassives = async ({
  programId,
  minQuestions,
  maxQuestions,
  selectedTestsIds,
  name,
}: {
  programId: string,
  minQuestions: number,
  maxQuestions: number,
  selectedTestsIds: string[],
  name: string,
}) => {
  const response = await axios.post('/api/massives', {
    programId,
    minQuestions,
    maxQuestions,
    selectedTestsIds,
    name,
  });

  return response.data;
};

const deleteMassive = async (massiveId: string) => {
  const response = await axios.delete(`/api/massives/${massiveId}`);

  return response.data;
};

const getPrograms = async (year?: number) => {
  let url = '/api/massives/get/programs';
  if (year) {
    url += `?year=${year}`;
  }
  const response = await axios.get(url);

  return response.data;
};

const getTests = async (programId: string) => {
  const response = await axios.get(`/api/massives/get/tests/${programId}`);

  return response.data;
};

const getSectionsAndPrograms = async (year?: number, cancelToken?: CancelToken) => {
  let url = '/api/massives/get/filters-information';
  if (year) {
    url += `?year=${year}`;
  }
  const response = await axios.get(url, { cancelToken });

  return response.data;
};

const getQuestionsAnswersZip = async (massiveId: string) => {
  const response = await axios.get(`/api/massives/download-questions-anwsers/${massiveId}`);

  return response.data;
};

export {
  getMassivesPerPage,
  postMassives,
  deleteMassive,
  getPrograms,
  getTests,
  getSectionsAndPrograms,
  getQuestionsAnswersZip,
};
